import config from 'config'
import React, { forwardRef } from 'react'
import { useTheme } from '@emotion/react'
import MatrixReactionsRowAddButton from 'matrix-react-sdk/lib/components/views/messages/ReactionsRowAddButton'

const ReactionsRowAddButton = forwardRef((props, ref) => {
  const theme = useTheme()
  return (
    <MatrixReactionsRowAddButton
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      ref={ref}
      theme={theme}
      width={config.emojiWidth}
      height={config.emojiHeight}
    />
  )
})

export default ReactionsRowAddButton
